<div class="top-header">
  <div class="container-fluid px-3 px-md-5 d-flex flex-column flex-md-row justify-content-between align-items-center py-2 text-white">
    
    <div class="contact-info text-center text-md-start">
      <strong *ngIf="!isMobile">Get in touch!</strong>
      <i class="fas fa-phone-alt ms-2"></i>&nbsp;
      <span class="me-2" *ngIf="!isMobile">+91-7004321674</span>
      <span class="me-2" *ngIf="!isMobile">+91-7827370883</span>
      <span class="me-2" *ngIf="isMobile">+91-7004321674 / +91-7827370883</span>
      <span class="divider d-md-inline">|</span>
      <i class="fas fa-home"></i>&nbsp;
      <span>Anand Vihar, Institutional Area, SH-55, Begusarai - 851218</span>
    </div>

    <div class="codes text-center text-md-end">
      <span class="text-warning fw-semibold">CBSE Affiliation No. 330251</span>
      <span class="divider d-md-inline">|</span>
      <span class="text-dark fw-semibold">School Code: 65245</span>
    </div>
  </div>
</div>


<nav class="navbar navbar-expand-lg bg-light">
    <div class="container-fluid">
      <div class="navbar-brand d-flex">
          <div><a [routerLink]="['/home']" class="sch-logo-link"><img src="assets/rvsLogo.jpg" alt="School Logo" class="sch-logo"></a></div>
          <div class="ms-1 sch-name-div">
              <span>River</span>
              <span>Valley</span>
              <span>School</span>
          </div>
      </div>
      <button class="pay-fees-btn" [routerLink]="['/online-fees']">Pay Fees</button>

      <button class="navbar-toggler" (click)="toggleMenu()" type="button" data-bs-toggle="collapse"
          data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span *ngIf="!isMenuOpen" class="fas fa-bars"></span>
          <span *ngIf="isMenuOpen" class="fas fa-times"></span>
      </button>

      <div class="collapse navbar-collapse justify-content-center" id="navbarNav">
          <ul class="navbar-nav">
              <li class="nav-item">
                  <a class="nav-link" routerLinkActive="active" [routerLink]="['/home']">Home</a>
              </li>

              <li class="nav-item dropdown">
                  <a class="nav-link dropdown-toggle" href="#" id="aboutUsDropdown" role="button"
                      data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      About Us
                  </a>
                  <div class="dropdown-menu" aria-labelledby="aboutUsDropdown">
                      <a class="dropdown-item" routerLinkActive="active" [routerLink]="['/aboutUs']">About
                          Institution</a>
                      <a class="dropdown-item" routerLinkActive="active" [routerLink]="['/directorMsg']">People
                          Behind The Vision</a>
                  </div>
              </li>

              <li class="nav-item dropdown">
                  <a class="nav-link dropdown-toggle" href="#" id="academicDropdown" role="button"
                      data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Academic
                  </a>
                  <div class="dropdown-menu" aria-labelledby="academicDropdown">
                      <a class="dropdown-item" routerLinkActive="active" [routerLink]="['/academic']">Admissions</a>
                      <a class="dropdown-item" routerLinkActive="active" [routerLink]="['/curriculum']">Curriculum
                          CBSE</a>
                  </div>
              </li>

              <li class="nav-item">
                  <a class="nav-link" routerLinkActive="active" [routerLink]="['/gallery']">Gallery</a>
              </li>
              <li class="nav-item">
                  <a class="nav-link" routerLinkActive="active" [routerLink]="['/pubDis']">Public Disclosure</a>
              </li>
              <li class="nav-item">
                  <a class="nav-link" routerLinkActive="active" [routerLink]="['/contact']">Contact Us</a>
              </li>
          </ul>
      </div>
    </div>
</nav>
